export function cloneStyled<T>(_: T, other: any): T {
  return other as T;
}
